import React from 'react';
import { Building2 } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-3">
          <div className="col-span-1 lg:col-span-2" data-id="element-4">
            <div className="flex items-center gap-2 text-white text-xl font-bold mb-4" data-id="element-5">
              <Building2 className="h-6 w-6 text-blue-500" data-id="element-6" />
              POWERQUEST
            </div>
            <p className="max-w-md text-slate-400 mb-6" data-id="element-7">
              Professional financial planning services dedicated to preserving
              and growing wealth for generations.
            </p>
          </div>

          <div data-id="element-8">
            <h4 className="text-white font-semibold mb-4" data-id="element-9">Legal Address</h4>
            <address className="not-italic text-sm leading-6" data-id="element-10">
              SYNTHOS KRS 0000038981
              <br data-id="element-11" />
              ul. CHEMIKÓW 1/---
              <br data-id="element-12" />
              32-600 OŚWIĘCIM
              <br data-id="element-13" />
              Poland
            </address>
          </div>

          <div data-id="element-14">
            <h4 className="text-white font-semibold mb-4" data-id="element-15">Services</h4>
            <ul className="space-y-2 text-sm" data-id="element-16">
              <li data-id="element-17">Wealth Orchestration</li>
              <li data-id="element-18">Capital Trajectory</li>
              <li data-id="element-19">Legacy Architecture</li>
              <li data-id="element-20">Liquidity Mapping</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-21">
          <p data-id="element-22">© 2026 Powerquest. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-23">
            <span className="hover:text-white cursor-pointer transition-colors" data-id="element-24">
              Privacy Policy
            </span>
            <span className="hover:text-white cursor-pointer transition-colors" data-id="element-25">
              Terms of Service
            </span>
            <span className="hover:text-white cursor-pointer transition-colors" data-id="element-26">
              Disclosures
            </span>
          </div>
        </div>
      </div>
    </footer>;
}